var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"interest_container"},_vm._l((_vm.interests),function(interest){return _c('div',{key:interest.id,staticClass:"interest_card"},[_c('div',{staticClass:"interest_icon"},[_vm._v(_vm._s(interest.icon))]),_c('div',{staticClass:"interest_name"},[_vm._v(_vm._s(interest.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }